import { render } from "./gszx.vue?vue&type=template&id=dfaaa03a&scoped=true&ts=true"
import script from "./gszx.vue?vue&type=script&lang=ts"
export * from "./gszx.vue?vue&type=script&lang=ts"

import "./gszx.vue?vue&type=style&index=0&id=dfaaa03a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfaaa03a"]])

export default __exports__